class commonFunction {
  getStringShortDate(date) {
    var currentDate = new Date(date)
    var currentDayOfMonth = currentDate.getDate()
    var currentMonth = String(currentDate.getMonth() + 1).padStart(2, '0') // January is 0, not 1
    var currentYear = currentDate.getFullYear()

    return [currentDayOfMonth, currentMonth, currentYear].join('/')
  }

  getStringDate(date) {
    if (date == undefined || date == null) return ''

    var currentDate = new Date(date)
    var currentHours = String(currentDate.getHours()).padStart(2, '0')
    var currentMinutes = String(currentDate.getMinutes()).padStart(2, '0')

    return (
      this.getStringShortDate(date) + ' ' + currentHours + ':' + currentMinutes
    )
  }

  /**
   * Converte una data locale in UTC (ISO stringa con 'Z')
   */
  convertDateToUTC(value) {
    if (!value) return value
    const date = new Date(value)
    return date.toISOString() // converte automaticamente da locale → UTC
  }

  convertDateFromUTC(value) {
  if (value == null) return value;

  // Se è già un Date
  if (value instanceof Date) return value;

  // Se è un numero (ms dall'epoch)
  if (typeof value === 'number') return new Date(value);

  if (typeof value === 'string') {
    const str = value.trim();

    // 1) Formato .NET /Date(1234567890000)/
    const msMatch = /\/Date\((-?\d+)\)\//.exec(str);
    if (msMatch) {
      return new Date(parseInt(msMatch[1], 10));
    }

    // 2) Se termina con Z o con offset (es. +01:00), new Date lo interpreta come UTC/offset-aware
    if (/[zZ]$/.test(str) || /[+-]\d{2}:\d{2}$/.test(str)) {
      const d = new Date(str);
      return isNaN(d.getTime()) ? null : d;
    }

    // 3) ISO senza timezone: "YYYY-MM-DDTHH:mm:ss(.fractional up to 7)?" 
    //    (supporta frazioni come .1 .. .1234567)
    if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d{1,7})?$/.test(str)) {
      const d = new Date(str + 'Z'); // forza interpretazione come UTC
      return isNaN(d.getTime()) ? null : d;
    }

    // 4) fallback: prova a creare new Date
    const d = new Date(str);
    if (!isNaN(d.getTime())) return d;
  }

  // non parseabile
  return null;
}

  dateAreEqual(date1, date2) {
    if (date1 == undefined || date1 == null) {
      if (date2 == undefined || date2 == null) {
        return true
      } else {
        return false
      }
    } else {
      var date1Date = new Date(date1)
      var date2Date = new Date(date2)
      return date1Date.getTime() == date2Date.getTime()
    }
  }
}

export default new commonFunction()
